import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import CameraOperatorsService from "../../../../services/AuraCamera/camera-operators/camer-operators.service";
const AddEditCamerOperator = (EditData: any) => {
  const session = window.localStorage;
  const toast = useRef<any>(null);
  var navigate = useNavigate();
  const [InitialDate, setInitialDate] = useState<any>(null);
  const [LastDate, setLastDate] = useState<any>(null);
  const id = EditData?.AllUpdateData?.userID;
  const EditData1 = EditData.AllUpdateData;
  const [EditDatatState, setEditDatatState] = useState<any>(null);
// for success toast.

useEffect(() => {
  if (session.getItem("setSiteUpdateToastFlag") == "true") {
    session.setItem("setSiteUpdateToastFlag", "false");

    showToast("success", "Site Updated", "Site Updated successfully.");
  }

  if (session.getItem("setCameraOperatorCreateToastFlag") == "true") {
    session.setItem("setCameraOperatorCreateToastFlag", "false");

    showToast("success", "Site Created", "Site Created successfully.");
  }

  
}, []);

const showToast = (
  severityValue: any,
  summaryValue: any,
  detailValue: any
) => {
  toast?.current?.clear();
  toast?.current?.show({
    severity: severityValue,
    summary: summaryValue,
    detail: detailValue,
  });
};
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      InitialDate1: "",
      LastDate1: "",
      email1: "",
      operatorCustomJobTitle: "",
      ContactNumber: "",
      comment: "",
      ogiInitialTraining: "",
    },
  });

  
  useEffect(() => {
    setEditDatatState(EditData.AllUpdateData);
   
    if (id) {
      let temp_start_date:any = new Date(EditData1?.initial_training_date);
      let temp_end_date:any = new Date(EditData1?.last_training_Date);
      setInitialDate(temp_start_date);
      setLastDate(temp_end_date);
      reset({
        firstName:EditData1?.firstName ,
        lastName: EditData1?.lastName,
        InitialDate1: temp_start_date,
        LastDate1: temp_end_date,
        email1: EditData1?.email,
        operatorCustomJobTitle: EditData1?.operatorCustomJobTitle,
        ContactNumber: EditData1?.contact_number,
        comment: EditData1?.comment,
        ogiInitialTraining: EditData1?.ogi_initial_training,
      });
    }
  }, [EditData]);
  const onSubmit = async (data: any) => {
    var payload = {
      ...data,
      InitialDate1: InitialDate,
      LastDate1: LastDate,
    };
    
    if (id) {
      // Update Site
      const updatedResponse = await CameraOperatorsService.UpdateCameraOperatorsData(
        payload,
        id,
        EditData1?.customerID
      );
      if (updatedResponse === "success") {
        session.setItem("setCameraOperatorUpdateToastFlag", "true");
        navigate(`/aura-camera/camera-operators`);
      } else {
        showToast("error", "Error", "Something went wrong, please try again!");
      }
    } else {
      const postResponse = await CameraOperatorsService.AddCameraOperatorsData(
        payload
      );

      if (postResponse == "error") {
        showToast("error", "Error", "Something went wrong, please try again!");
      } else {
        session.setItem("setCameraOperatorCreateToastFlag", "true");
        navigate(`/aura-camera/camera-operators`);
      }
    }
  };
  return (
    <>
    <Toast ref={toast} style={{ marginTop: "25px", zIndex: 9999 }} />
      <form
        className="row"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="new-password"
        spellCheck={false}
      >
        {/* First Name start */}
        <div className="col-md-6">
          <label className="form-label">First name</label>
          <sup className="required">*</sup>

          <input
            type="text"
            {...register("firstName", {
              required: true,
              pattern: /^[a-zA-Z ]+$/i,
            })}
            name="firstName"
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
          {errors?.firstName?.type === "required" && (
            <span className="error">First name is required</span>
          )}

          {errors?.firstName?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>
        {/* First Name end*/}

        <div className="col-md-6">
          <label className="form-label">Initial training date</label>
          <sup className="required">*</sup>
          <Calendar
            placeholder="select"
            className="form-control"
            value={
              InitialDate
            }
            {...register("InitialDate1", {
              required: InitialDate == null ? true : false,
            })}
            name="InitialDate1"
            onChange={(e) => {
              setInitialDate(e.value);
            }}
            showIcon
            style={{ padding: 0, margin: 0 }}
          />
          {errors?.InitialDate1?.type === "required" && (
            <span className="error">Initial date is required</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Last name</label>
          <sup className="required">*</sup>

          <input
            type="text"
            {...register("lastName", {
              required: true,
              pattern: /^[a-zA-Z ]+$/i,
            })}
            
            name="lastName"
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
          {errors?.lastName?.type === "required" && (
            <span className="error">Last name is required</span>
          )}
          {errors?.lastName?.type === "pattern" && (
            <span className="error">Alphabetical characters only</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Last training date</label>
          <sup className="required">*</sup>
          <Calendar
            placeholder="select"
            className="form-control"

            value={
              LastDate
            }
            {...register("LastDate1", {
              required: LastDate == null ? true : false,
            })}
            onChange={(e) => setLastDate(e.value)}
            name="LastDate1"
            showIcon
            style={{ padding: 0, margin: 0 }}
          />
          {errors?.LastDate1?.type === "required" && (
            <span className="error">Last date is required</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Email ID</label>
          <sup className="required">*</sup>

          <input
            type="text"
           
            {...register("email1", {
              required: true,
              pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
            })}
            name="email1"
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
          {errors?.email1?.type === "required" && (
            <span className="error">Email is required</span>
          )}

          {errors?.email1?.type === "pattern" && (
            <span className="error">Email not in format</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Operator custom job title</label>
          <sup className="required">*</sup>

          <input
            type="text"
            
            {...register("operatorCustomJobTitle", {
              required: true,
            })}
            name="operatorCustomJobTitle"
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
          {errors?.operatorCustomJobTitle?.type === "required" && (
            <span className="error">Title is required</span>
          )}
        </div>

        <div className="col-md-6">
          <label className="form-label">Contact number</label>
          <sup className="required">*</sup>

          <input
            type="text"
            
            {...register("ContactNumber", {
              required: true,
              pattern: /^\d{10}$/,
            })}
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
          {errors?.ContactNumber?.type === "required" && (
            <span className="error">Contact is required</span>
          )}

          {errors?.ContactNumber?.type === "pattern" && (
            <span className="error">Phone number not in format</span>
          )}
        </div>

        <div className="col-md-6"></div>
        <div className="col-md-6">
          <label className="form-label">Comment</label>
          <textarea
            // type="text"
            
            {...register("comment", {
              required: false,
            })}
            placeholder="Enter text here"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
          />
        </div>
        <div className="col-md-6"></div>
        <div className="col-md-6">
          <label className="form-label">
            OGI initial training<sup className="required">*</sup>
          </label>
          <select
            // value={idData?.customerId}
            // {...register("customerId", { required: true })}
           
            className="form-control"
            autoComplete="off"
            {...register("ogiInitialTraining", {
              required: true,
            })}
            // onChange={editNewData}
            // onChange={(e: any) => handleCustomerNameChange(e)}
            // disabled={customerNameDisabled}
          >
            <option key={1} value={"true"}>
              True
            </option>

            <option key={2} value={"false"}>
              False
            </option>
          </select>
          {errors?.ogiInitialTraining?.type === "required" && (
            <span className="error">This field is required</span>
          )}
        </div>

        <div className="col-md-12 btngroup">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => navigate(`/aura-camera/camera-operators`)}
          >
            <i className="pi pi-arrow-left"></i> Back
          </button>
          <input type="submit" value={"Submit"} className="btn btn-primary" />
        </div>
      </form>
    </>
  );
};

export default AddEditCamerOperator;
